import { Grid, Menu } from "semantic-ui-react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { useIntl } from "react-intl";
import { useFlags } from "launchdarkly-react-client-sdk";
import useIsAdmin from "../../common/hooks/useIsAdmin";

const PixelGridHeader = () => {
  const intl = useIntl();
  const location = useLocation();
  const {
    whitelabelEventPixelCreateButton,
    whitelabelRoiPixelEnabled,
    whitelabelRetargetingSegments,
    whitelabelUploadDeviceButton,
  } = useFlags();
  const isAdminUser = useIsAdmin();
  const isDeviceIdPage = location.pathname === "/deviceid";
  const shouldDisplayRetargetingSegments = whitelabelRetargetingSegments;

  return (
    <Grid className="common_grid">
      <Grid.Row>
        <Grid.Column>
          <Menu pointing secondary>
            <Menu.Item
              as={NavLink}
              to="/pixels"
              content={intl.formatMessage({
                id: "LINK_PIXELS",
                defaultMessage: "Pixels",
              })}
            />
            <Menu.Item
              as={NavLink}
              to="/deviceid"
              content={intl.formatMessage({
                id: "LINK_DEVICE_ID",
                defaultMessage: "Device ID",
              })}
            />
            {shouldDisplayRetargetingSegments && <Menu.Item
              as={NavLink}
              to="/retargeting-segments"
              content={intl.formatMessage({
                id: "LINK_BRAND_AND_SKU_SEGMENTS",
                defaultMessage: "Brand and SKU Segments",
              })}
            />}
            <Menu.Menu position="right">
              <Menu.Item
                style={{ gap: "0.5rem", paddingLeft: "0", paddingRight: "0" }}
              >
                {whitelabelUploadDeviceButton && isDeviceIdPage && (
                  <Link
                    className="text__uppercase ui button compact primary"
                    to="/deviceid/create"
                  >
                    {intl.formatMessage({
                      id: "BTN_UPLOAD_DEVICE_ID",
                      defaultMessage: "Upload Device ID",
                    })}
                  </Link>
                )}
                {whitelabelEventPixelCreateButton && (
                  <Link
                    className="text__uppercase ui button compact primary"
                    to="/pixel/create"
                    data-testid="add-event-pixel-button"
                  >
                    {intl.formatMessage({
                      id: "BTN_ADD_EVENT_PIXEL",
                      defaultMessage: "Add Event Pixel",
                    })}
                  </Link>
                )}
                {whitelabelRoiPixelEnabled && (
                  <Link
                    className="text__uppercase ui button compact primary"
                    to="/pixel-roi/create"
                    data-testid="add-roi-pixel-button"
                  >
                    {intl.formatMessage({
                      id: "BTN_ADD_ROI_PIXEL",
                      defaultMessage: "Add ROI Pixel",
                    })}
                  </Link>
                )}
                {shouldDisplayRetargetingSegments && (
                  <Link
                    className="text__uppercase ui button compact primary"
                    to="/retargeting-segments/create"
                    data-testid="add-retargeting-segment-button"
                  >
                    {intl.formatMessage({
                      id: "BTN_BRAND_SKU_SEGMENTS",
                      defaultMessage: "Add Brand and SKU Segments",
                    })}
                  </Link>
                )}
              </Menu.Item>
            </Menu.Menu>
          </Menu>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default PixelGridHeader;
